import { styled } from "@mui/material";
import { COLORS } from "../../constants/colors";

export const SidebarContent = styled("div")`
  overflow: auto;
  background-color: ${COLORS.TRANSPARENT};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SidebarInnerContent = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
`;
